import Swiper from './lib/swiper-bundle.min';

export default () => {

  let $swiperParameter = {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    speed: 200,
    effect:'fade',
    navigation: {
      nextEl: ".swiper-modal-room-button-next",
      prevEl: ".swiper-modal-room-button-prev",
    },
    thumbs: {
      //swiper: sliderThumbnail,
    }
  };

  const $swiperElement1 = document.getElementById('swiper-modal-room1');
  if (!$swiperElement1) return;
  let SwiperMain = new Swiper($swiperElement1, $swiperParameter);

  const $swiperElement2 = document.getElementById('swiper-modal-room2');
  if (!$swiperElement2) return;
  let SwiperMain2 = new Swiper($swiperElement2, $swiperParameter);

  const $swiperElement3 = document.getElementById('swiper-modal-room3');
  if (!$swiperElement3) return;
  let SwiperMain3 = new Swiper($swiperElement3, $swiperParameter);

  const $swiperElement4 = document.getElementById('swiper-modal-room4');
  if (!$swiperElement4) return;
  let SwiperMain4 = new Swiper($swiperElement4, $swiperParameter);

  const listItems = document.querySelectorAll(".swiper-slide-room");

  listItems.forEach((li,index) => {
    li.addEventListener('click',() => {
      let url = li.dataset.url;
      // 対応するクラス要素を取得
      const targetEl = document.querySelector(`.${url}`);
      if (targetEl) {
        // いったん全部非表示にする場合（任意）
        document.querySelectorAll('.room_wrap').forEach(el => {
          el.style.display = 'none';
        });
        // 対象を表示
        targetEl.style.display = 'block';
      }
      let $swiperElement2 = document.getElementById('modal_wrap');
      $swiperElement2.classList.toggle('js-modal-open');
    })
  });

  const btnCloseModals = document.querySelectorAll('.js-room-modal-close,.js-btn-close-wrap');
  if (!btnCloseModals) return;
  btnCloseModals.forEach((btnCloseModal,index) => {
    btnCloseModal.addEventListener('click', function (event) {
      event.preventDefault();
      let ElementStudio = document.getElementById('modal_wrap');
      ElementStudio.classList.toggle('js-modal-open');
    });
  });

}
